import React from 'react';
import { Tooltip } from '@mui/material';
import styled from '@emotion/styled';
import LinkIcon from '@/public/icons/record/link2.svg';
import { useTranslation } from 'react-i18next';

interface CopyLinkButtonProps {
  onClick: () => void;
  tooltipTitle?: string;
  linkText?: string;
}

const CopyLinkButton: React.FC<CopyLinkButtonProps> = ({
  onClick,
  tooltipTitle,
  linkText,
}) => {
  const { t } = useTranslation();

  const defaultTooltipTitle = t(
    '이 회의록에 추가된 사람만 이 링크를 통해 조회할 수 있습니다.',
  );
  const defaultLinkText = t('링크 복사');

  return (
    <Tooltip
      title={tooltipTitle || defaultTooltipTitle}
      arrow
      placement="bottom-start"
      slotProps={{
        tooltip: {
          sx: {
            backgroundColor: 'rgba(0, 0, 0, 1)',
            color: '#FFF',
            fontSize: '11px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '20px',
            whiteSpace: 'nowrap',
            '& .MuiTooltip-arrow': {
              color: 'var(--dk-text, rgba(0, 0, 0, 1))',
            },
          },
        },
      }}
    >
      <StyledLink onClick={onClick}>
        <LinkIcon />
        {linkText || defaultLinkText}
      </StyledLink>
    </Tooltip>
  );
};

export default CopyLinkButton;

const StyledLink = styled.button`
  display: flex;
  align-items: center;
  color: var(--dk-accent, #06c);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  gap: 4px;
  border-radius: 2px;
  :hover {
    background-color: rgba(0, 102, 204, 0.12);
  }
`;
